<template>
  <div class="row justify-content-center">
    <div>
      <div class="wc-gift-card" ref="giftcard">
        <div v-if="gc.design" class="d-flex justify-content-around text-center">
          <WCImage
            :imageSrc="`${$configuration.cdn}/api/img/${gc.design.image}`"
            :imageAlt="$t('giftCardImgAltText')"
            imageClass="wc-gift-card__design-image"
            imageStyle="max-width: 100%;"
            defaultClass="font-size-7xl wc-gift-card__design-image"
            id="gift-card__img"
          />
        </div>

        <div v-else>
          <div class="wc-gift-card__default-design">
            <div class="wc-gift-card__text" v-if="!gc.dynamic">{{ $t('eGiftCard') }}</div>
            <div class="wc-gift-card__text" v-if="gc.dynamic">{{ $t('voucher') }}</div>
          </div>
        </div>

        <div>
          <h3 class="wc-gift-card__balance">
            {{ $t('balance') }}: {{ gc.balance || gc.amount | currency }}
          </h3>
          <p v-if="gc.recipientName" id="gift-card-recipient__name">
            {{ $t('toCap') }}: {{ gc.recipientName }}
          </p>
          <p v-if="gc.senderName" id="gift-card-sender__name">
            {{ $t('from') }}: {{ gc.senderName }}
          </p>
          <p v-if="gc.message" id="gift-card__msg">{{ $t('message') }}: {{ gc.message }}</p>
          <WCBarcode class="wc-gift-card__barcode" v-if="gc.account" :data="giftCardCode" />
          <p class="wc-gift-card__barcode-text" v-if="gc && gc.account">
            {{ giftCardCode.substring(1) }}
          </p>
        </div>
      </div>

      <button
        class="btn btn-primary btn-block m-auto"
        id="gift-card-print__button"
        @click="print()"
      >
        {{ $t('print') }}
      </button>
    </div>
  </div>
</template>
<script>
import WCBarcode from '@/components/WCBarcode/WCBarcode.vue';
import WCImage from '@/components/WCImage/WCImage.vue';

export default {
  name: 'WCGiftCard',
  components: { WCBarcode, WCImage },
  props: {
    gc: Object,
  },
  computed: {
    giftCardCode() {
      if (this.gc.code !== 0) {
        return '^'.concat(this.gc.code.concat(this.gc.account));
      }
      return '^'.concat(this.gc.account);
    },
  },
  methods: {
    print() {
      const printWindow = window.open('', '_blank');

      printWindow.document.open();
      printWindow.document.write(`
              <html>
                  <head>
                      <link rel="stylesheet" href="/theme.min.css">
                  </head>
                  <body onload="window.print()">
                      <style>
                        .wc-gift-card {
                            margin: 1rem auto;
                            padding: 0.75rem;
                            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
                            border-radius: 10px;
                        }

                        .wc-gift-card__design-image {
                            max-width: 100%;
                            margin-bottom: 0.75rem;
                            border-radius: 5px;
                        }

                        .wc-gift-card__balance {
                            margin-top: 0;
                        }

                        .wc-gift-card__barcode {
                            display: block;
                            margin: 0.75rem auto;
                        }

                        .wc-gift-card__barcode-text {
                            text-align: center;
                            margin-bottom: 1rem;
                        }
                        
                      </style>  
                      <div style="width: 400px;">
                          ${this.$refs.giftcard.outerHTML}
                      </div>
                  </body>
              </html>
          `);
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-gift-card {
  margin: 1rem auto;
  padding: $pad-3 * 0.75;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.wc-gift-card__balance {
  font-family: Helvetica;
  margin-top: 0;
}

.wc-gift-card__design-image {
  max-width: 100%;
  margin-bottom: $margin-3 * 0.75;
  border-radius: 5px;
}

.wc-gift-card__barcode {
  display: block;
  margin-top: $margin-4;
}

.wc-gift-card__barcode-text {
  text-align: center;
  margin-bottom: $margin-3;
  max-width: 100%;
  text-overflow: wrap;
}

.wc-gift-card__text {
  padding: $pad-1 * 1.25;
  font-size: $font-size-3xl;
}

.wc-gift-card__default-design {
  height: rem(150px);
  background: var(--primary, get-color('primary'));
  color: var(--primary-contrast, get-color-contrast('primary'));
  border-radius: 5px;
}
</style>
